import { MATRIX_BACKEND } from '@/remotes';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { ref, toRef, watch, watchEffect } from 'vue';

export function useGetAvailableCargoNatures() {
  const cargoNatures = ref([]);
  const cargoInformation = useNewDataFormCargoPickUpStore().cargoInformation;
  const cargoType = toRef(cargoInformation, 'typeOfCargo');
  const resetCargoNature = () => {
    cargoInformation.natureOfCargo = null;
  };
  watch(
    () => cargoType.value.id,
    () => {
      resetCargoNature();
    }
  );

  watchEffect(async () => {
    if (cargoType.value.id === 3) {
      cargoInformation.natureOfCargo = {
        id: 74,
        title: 'Шины',
      };
      cargoNatures.value = [
        {
          id: 74,
          title: 'Шины',
        },
      ];
    } else {
      try {
        cargoNatures.value = (await MATRIX_BACKEND.get('/api/public/cargo-natures')).data;
      } catch {
        cargoNatures.value = [];
      }
    }
  });

  return cargoNatures;
}
